module.exports = __webpack_public_path__ + "img/mobileprogrammeBanner.343cd261.png";